import { CheckIcon, CloseIcon, DeleteIcon, EditIcon, HamburgerIcon } from '@chakra-ui/icons';
import {
  Button,
  Checkbox,
  Flex,
  HStack,
  IconButton,
  Input,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  VStack,
  useColorModeValue,
  useDisclosure,
  Tooltip,
  useToast
} from '@chakra-ui/react';
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import UsuariosController from "controllers/Usuarios/UsuariosController";
import { useEffect, useState } from 'react';

function UsuariosView() {
  const [data, setData] = useState([]);
  const [newUsuarioLogin, setNewUsuarioLogin] = useState("");
  const [newUsuarioSenha, setNewUsuarioSenha] = useState("");
  const [newUserEmail, setNewUserEmail] = useState("");
  const textColor = useColorModeValue("gray.700", "white");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await UsuariosController.ListUsers();
        setData(response);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  const addUsuario = async () => {
    try {
      const response = await UsuariosController.AddUser(newUsuarioLogin, newUsuarioSenha, newUserEmail);
      if (response) {
        const newUsuarios = await UsuariosController.ListUsers();
        setData(newUsuarios);
        setNewUsuarioLogin("");
        setNewUsuarioSenha("");
        setNewUserEmail("");
      }
    } catch (error) {
      console.error("Error adding usuario:", error);
    }
  };

  return (
    <Flex direction='column' height={"100%"} width="100%">
      <Card overflowX={{ sm: "scroll", xl: "hidden" }}>
        <CardHeader>
          <VStack spacing={2} align="stretch">
            <HStack spacing={2}>
              <Input
                value={newUsuarioLogin}
                onChange={(e) => setNewUsuarioLogin(e.target.value)}
                placeholder="Login"
              />
              <Input
                value={newUsuarioSenha}
                onChange={(e) => setNewUsuarioSenha(e.target.value)}
                placeholder="Senha"
              />
              <Input
                value={newUserEmail}
                onChange={(e) => setNewUserEmail(e.target.value)}
                placeholder="E-mail"
              />
              <Button onClick={addUsuario} colorScheme="blue" width="auto" minWidth="200px">
                Adicionar
              </Button>
            </HStack>
          </VStack>
        </CardHeader>
        <CardBody>
          <Table variant='simple' color={textColor}>
            <Thead>
              <Tr color='gray.400'>
                <Th color={textColor}>USUÁRIO</Th>
                <Th color={textColor}>E-MAIL</Th>
                <Th color={textColor}>DATA DE CRIAÇÃO</Th>
                <Th color={textColor}>Empresa</Th>
                <Th color={textColor}>Último acesso</Th>
                <Th color={textColor}>AÇÕES</Th>
              </Tr>
            </Thead>
            <Tbody>
              {data.map((usuario) => (
                <UsuarioRow key={usuario.id} usuario={usuario} setData={setData} />
              ))}
            </Tbody>
          </Table>
        </CardBody>
      </Card>
    </Flex>
  );
}

function UsuarioRow({ usuario, setData }) {
  const [isEditing, setIsEditing] = useState(false);
  const [editedLogin, setEditedLogin] = useState(usuario.login);
  const [editedEmail, setEditedEmail] = useState(usuario.email);
  const [menuSelections, setMenuSelections] = useState({
    'Dashboard': false,
    'Filas': false,
    'Bibliotecas de audio': false,
    'Audios': false,
    'Fichas': false,
    'Processamento automatico': false,
    'Transcricoes': false,
    'Relatorios': false,
    'Fichas individuais': false,
    'Resultado de uma ficha': false,
    'Monitoramento': false,
    'Operacoes': false,
    'Usuarios': false,
    'Logs': false
  });
  const { isOpen, onOpen, onClose } = useDisclosure();
  const toast = useToast();

  const editUsuario = async () => {
    try {
      const response = await UsuariosController.PutUser(usuario.id, editedLogin, editedEmail, menuSelections);
      if (response.status === 200) {
        const updatedUsuarios = await UsuariosController.ListUsers();
        setData(updatedUsuarios);
        setIsEditing(false);
        onClose();
        toast({
          title: "Usuário atualizado com sucesso!",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      } else {
        toast({
          title: "Erro ao atualizar usuário.",
          description: `Status: ${response.status}`,
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error("Error editing usuario:", error);
      toast({
        title: "Erro ao atualizar usuário.",
        description: "Ocorreu um erro ao tentar atualizar o usuário.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const deleteUsuario = async () => {
    try {
      const response = await UsuariosController.DeleteUser(usuario.id);
      if (response) {
        const updatedUsuarios = await UsuariosController.ListUsers();
        setData(updatedUsuarios);
      }
    } catch (error) {
      console.error("Error deleting usuario:", error);
    }
  };

  const handleMenuSelectionChange = (menu) => {
    setMenuSelections(prev => ({
      ...prev,
      [menu]: !prev[menu]
    }));
  };

  const handleSelectAll = (isChecked) => {
    const updatedSelections = Object.keys(menuSelections).reduce((acc, key) => {
      acc[key] = isChecked;
      return acc;
    }, {});
    setMenuSelections(updatedSelections);
  };

  const areAllSelected = Object.values(menuSelections).every(Boolean);

  return (
    <Tr>
      <Td>
        {isEditing ? (
          <Input value={editedLogin} onChange={(e) => setEditedLogin(e.target.value)} />
        ) : (
          usuario.login
        )}
      </Td>
      <Td>
        {isEditing ? (
          <Input value={editedEmail} onChange={(e) => setEditedEmail(e.target.value)} />
        ) : (
          usuario.email
        )}
      </Td>
      <Td>{usuario.date_creation}</Td>
      <Td>{usuario.name}</Td>
      <Td>{usuario.date_modified}</Td>
      <Td>
        <HStack spacing={2}>
          {isEditing ? (
            <>
              <IconButton
                aria-label="Confirmar edição"
                icon={<CheckIcon />}
                onClick={editUsuario}
              />
              <IconButton
                aria-label="Cancelar edição"
                icon={<CloseIcon />}
                onClick={() => {
                  setIsEditing(false);
                  onClose();
                }}
              />
            </>
          ) : (
            <IconButton
              aria-label="Editar"
              icon={<EditIcon />}
              onClick={() => setIsEditing(true)}
            />
          )}
          <IconButton icon={<DeleteIcon />} onClick={deleteUsuario} />
          <Tooltip label="Selecionar Menus">
            <IconButton
              icon={<HamburgerIcon />}
              variant="outline"
              aria-label="Menu"
              onClick={onOpen}
            />
          </Tooltip>
        </HStack>

        <Modal isOpen={isOpen} onClose={onClose} size="xl">
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Selecionar Menus</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <VStack align="start" spacing={2}>
                <Checkbox
                  isChecked={areAllSelected}
                  onChange={(e) => handleSelectAll(e.target.checked)}
                >
                  Selecionar Todos
                </Checkbox>
                {Object.keys(menuSelections).map((menu) => (
                  <Checkbox
                    key={menu}
                    isChecked={menuSelections[menu]}
                    onChange={() => handleMenuSelectionChange(menu)}
                  >
                    {menu}
                  </Checkbox>
                ))}
              </VStack>
            </ModalBody>
            <ModalFooter>
              <Button colorScheme="blue" mr={3} onClick={editUsuario}>
                Salvar
              </Button>
              <Button onClick={onClose}>Cancelar</Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </Td>
    </Tr>
  );
}

export default UsuariosView;